module.exports = __webpack_public_path__ + "img/QonLogo.70001f44.svg";